import { COLORS_FAMILY_KEY } from '@/constants/colors-family-key';
import {
  convertStateToNewFilter,
  getFilterStateFromPath,
  resolveCategoryLayerFilterLabels,
} from '@/util/category-filter-helper';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

const InitCategoryByQueryColor = ({
  useServerState,
  setClientCategoryFilter,
  categoryUrlKey,
  aggregations,
  filterOptions,
  categoryIntId,
  setCategoryFilterLabels,
  setClientFilterState,
  setInternalFilterState,
  setClientFilterColor,
  setIsInitBySearchParams,
}) => {
  const searchParams = useSearchParams();
  const pathname = usePathname();

  useEffect(() => {
    setIsInitBySearchParams(false);

    if (useServerState) return;

    const queryColor = searchParams.get('color');
    const queryColorsFamily = searchParams.get(COLORS_FAMILY_KEY);

    if (!queryColor && !queryColorsFamily) return;

    const { filterState } = getFilterStateFromPath({
      categoryUrlKey,
      aggregations,
      pathname,
      filterOptions,
      queryColorsFamily,
      queryColor,
    });
    const colorsFamilyOptions = filterOptions.find(x => x.attribute_code === COLORS_FAMILY_KEY)?.options || [];
    const colorOptions = filterOptions.find(x => x.attribute_code === 'custom_option_color_ids')?.options || [];
    const { colorsFamilyRewrite, colorRewrite } = pathname.split('/').reduce(
      (acc, cur, i, arr) => {
        if (cur && i > 0 && arr[i - 1] === COLORS_FAMILY_KEY) {
          acc.colorsFamilyRewrite = cur;
        }

        if (cur && i > 0 && arr[i - 1] === 'color') {
          acc.colorRewrite = cur;
        }

        return acc;
      },
      {
        colorsFamilyRewrite: '',
        colorRewrite: '',
      },
    );
    const queryColorsFamilyRewrites = queryColorsFamily?.split(',') || [];
    const queryColorRewrites = queryColor?.split(',') || [];
    const layerFilterLabels = resolveCategoryLayerFilterLabels({
      colorsFamilyRewrite,
      colorRewrite,
      colorOptions,
      aggregations,
      colorsFamilyOptions,
      filterState,
      queryColorsFamilyRewrites,
      queryColorRewrites,
    });

    setClientCategoryFilter({
      category_id: {
        eq: categoryIntId,
      },
      ...convertStateToNewFilter(filterState),
    });
    setClientFilterState(filterState);
    setInternalFilterState(filterState);
    setCategoryFilterLabels(layerFilterLabels);
    setClientFilterColor(
      (filterState.find(x => x.attributeCode === 'custom_option_color_ids')?.options || [])
        .map(x => x.label)
        .reverse()
        .join(','),
    );
  }, [
    searchParams,
    useServerState,
    categoryUrlKey,
    aggregations,
    pathname,
    filterOptions,
    setClientCategoryFilter,
    categoryIntId,
    setCategoryFilterLabels,
    setClientFilterState,
    setInternalFilterState,
    setClientFilterColor,
    setIsInitBySearchParams,
  ]);

  return null;
};

export default InitCategoryByQueryColor;
